import { cn } from '@dialogueconsulting/sked-ui/lib/utils'
import type { PropsWithChildren } from 'react'

import { Avatar, AvatarFallback, AvatarImage } from 'ui/avatar'

export interface AvatarComponentProps extends React.HTMLAttributes<HTMLSpanElement> {
  src: string
  alt: string
}

function AvatarComponent({
  src,
  alt,
  className,
  ...props
}: PropsWithChildren<AvatarComponentProps>) {
  const initial = alt.substring(0, 2).toUpperCase() // first two letters

  return (
    <Avatar
      className={cn(
        'grid size-auto place-content-center rounded-none',
        className
      )}
      {...props}
    >
      <AvatarImage src={src} alt={alt} />
      <AvatarFallback>{initial}</AvatarFallback>
    </Avatar>
  )
}

export default AvatarComponent
